import {
  addHeroBannerButton,
  updateHeroBannerButton,
  deleteHeroBannerButton,
} from "./heroBannerButtonsService";
import { buildButtonPayload } from "../components/CMS/HeroBanners/heroBannerUtils";

export const syncHeroBannerButtons = async (
  heroBannerId,
  buttons,
  deletedButtonIds = []
) => {
  for (const deletedId of deletedButtonIds) {
    if (deletedId) {
      await deleteHeroBannerButton(deletedId);
    }
  }

  for (let i = 0; i < buttons.length; i += 1) {
    const button = { ...buttons[i], displayOrder: i + 1 };
    const payload = buildButtonPayload(button, heroBannerId);
    if (button.id) {
      await updateHeroBannerButton(payload);
    } else {
      await addHeroBannerButton(payload);
    }
  }
};
